import fetch from 'cross-fetch';

const deletePDF = async (key) => {
  const removeResponse = await fetch(`https://pdfapi.rockdelux.com/production/delete?key=${key}`, { method: 'DELETE' });

  if (removeResponse.status >= 400) {
    throw new Error('Could not remove file from S3');
  }
};

export default deletePDF;
